import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CookingIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CookingIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M20.4224 10.2033H3.93799C2.96873 10.2033 2.18018 10.9919 2.18018 11.9611C2.18018 13.3759 3.1883 14.5596 4.52393 14.8318V19.0704C4.52393 20.6858 5.83819 22 7.45361 22H16.9067C18.5222 22 19.8364 20.6858 19.8364 19.0704V14.8318C21.172 14.5596 22.1802 13.3759 22.1802 11.9611C22.1802 10.9919 21.3916 10.2033 20.4224 10.2033ZM3.35205 11.9611C3.35205 11.638 3.6149 11.3752 3.93799 11.3752H4.52393V13.6181C3.84193 13.3762 3.35205 12.7249 3.35205 11.9611ZM18.6646 19.0704C18.6646 20.0396 17.876 20.8281 16.9067 20.8281H7.45361C6.48435 20.8281 5.6958 20.0396 5.6958 19.0704V11.3752H18.6646V19.0704ZM19.8364 13.6181V11.3752H20.4224C20.7454 11.3752 21.0083 11.638 21.0083 11.9611C21.0083 12.7249 20.5184 13.3762 19.8364 13.6181Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.4247 5.13142C18.4247 4.80783 18.1623 4.54549 17.8387 4.54549C17.7291 4.54549 16.7509 4.56194 16.1815 5.13142C15.6119 5.7009 15.5955 6.67901 15.5955 6.78869C15.5955 6.99299 15.5244 7.44583 15.3528 7.6173C15.1906 7.77961 14.7611 7.85809 14.5242 7.85999C14.2006 7.85999 13.9383 8.12233 13.9383 8.44592C13.9383 8.76951 14.2006 9.03185 14.5242 9.03185C14.6339 9.03185 15.612 9.0154 16.1815 8.44592C16.751 7.87644 16.7674 6.89833 16.7674 6.79095C16.7693 6.55177 16.8478 6.12233 17.0101 5.96002C17.1723 5.7978 17.6015 5.71932 17.8408 5.71733C18.1634 5.71624 18.4247 5.45434 18.4247 5.13142Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0398 9.03186C18.1495 9.03186 19.1276 9.01541 19.6971 8.44593C20.2666 7.87645 20.283 6.89834 20.283 6.79096C20.2849 6.55179 20.3634 6.12234 20.5257 5.96003C20.6879 5.79781 21.1172 5.71933 21.3564 5.71735C21.6791 5.71625 21.9403 5.45434 21.9403 5.13142C21.9403 4.80783 21.678 4.54549 21.3544 4.54549C21.2447 4.54549 20.2666 4.56194 19.6971 5.13142C19.1276 5.7009 19.1112 6.67901 19.1112 6.78869C19.1112 6.99299 19.04 7.44583 18.8685 7.6173C18.7062 7.77961 18.2767 7.85809 18.0399 7.85999C17.7163 7.85999 17.4539 8.12233 17.4539 8.44592C17.4539 8.76951 17.7162 9.03186 18.0398 9.03186Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.61653 8.68962C4.75122 8.98329 5.0988 9.11301 5.39341 8.97789L18.1674 3.11863C18.4615 2.98371 18.5906 2.63591 18.4556 2.34177C18.3207 2.04764 17.9729 1.91858 17.6788 2.0535L13.4254 4.00444L13.4201 3.99284C12.8797 2.81896 11.4849 2.30353 10.311 2.84395C9.13706 3.38437 8.62166 4.77907 9.16209 5.95295L9.16475 5.95878L4.90483 7.91277C4.61069 8.04769 4.48162 8.39548 4.61653 8.68962ZM10.2266 5.46292C9.95638 4.87598 10.2141 4.17861 10.801 3.90842C11.388 3.63823 12.0853 3.89592 12.3556 4.48286L12.3602 4.49301L10.2299 5.47018L10.2266 5.46292Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CookingIcon;
